import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { LogCategory, LogCoreComponent, LoggerService, LogType } from '../services/logger.service';

@Component({
    selector: 'app-ocid',
    templateUrl: './ocid.component.html',
    styleUrls: ['./ocid.component.scss'],
    standalone: false
})
export class OcidComponent implements OnInit, OnDestroy {
    private code: string;
    private sub: Subscription;

    constructor(
        private route: ActivatedRoute,
        private authentication: AuthenticationService,
        private logger: LoggerService
    ) {
        this.log("constructor", null, LogCategory.Constructor);

        this.route.queryParams.subscribe(params => {
            this.code = params['code'];
        });
    }

    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.CoreComponent, LogCoreComponent.Ocid, category);
    }

    ngOnInit() {

        this.log("ngOnInit", `code is ` + this.code, LogCategory.Init);

        // If we have a code then start the login and token exchange process 
        if (this.code) {
            this.authentication.getAccessToken(this.code); 
        }
        else { // If we don't have a code, then we shouldn't be here, so redirect back to login
            this.authentication.logout();
        }
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", null, LogCategory.Destroy);
        if (!!this.sub) {
            this.sub.unsubscribe();
        }
    }
}
